import React from 'react';
import { Link } from 'react-router-dom';
import { PageShell, QuoteButton } from '../components/site/PageParts';
import useSeo from '../hooks/useSeo';

export default function NotFound() {
  useSeo({ title: 'Page Not Found | Pusha Teez', description: 'This page could not be found.', noindex: true, canonical: false });
  return (
    <PageShell testid="not-found-page">
      <section className="px-6 py-24 md:py-36">
        <div className="max-w-3xl mx-auto text-center">
          <p className="font-display text-[#00b8ff] text-7xl md:text-9xl tracking-tight">404</p>
          <h1 className="font-display text-[#f4efe6] uppercase text-4xl md:text-6xl tracking-tight mt-4">Page not found</h1>
          <p className="text-[#cfc8bb] text-base md:text-lg mt-6">
            The page you&apos;re looking for doesn&apos;t exist or has moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
            <Link to="/production" className="inline-flex items-center justify-center border border-white/20 text-[#f4efe6] rounded-full px-8 py-4 font-semibold hover:border-[#00b8ff] transition-colors duration-200" data-testid="not-found-production-link">
              Go to Production
            </Link>
            <QuoteButton testid="not-found-quote-btn" />
          </div>
        </div>
      </section>
    </PageShell>
  );
}
